import { render } from "./AdminShiftCreate.vue?vue&type=template&id=7d9c36b5&scoped=true&ts=true"
import script from "./AdminShiftCreate.vue?vue&type=script&lang=ts"
export * from "./AdminShiftCreate.vue?vue&type=script&lang=ts"

import "./AdminShiftCreate.vue?vue&type=style&index=0&id=7d9c36b5&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9c36b5"]])

export default __exports__